module.exports = __webpack_public_path__ + "static/media/refer.2f286769.png";